var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Anchor as ArcoAnchor } from '@arco-design/web-react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import { IconWarning } from '@arco-design/iconbox-react-m4b-next';
import { ErrorLinkListContext } from './anchor';
var LinkRender = function (props) {
    var title = props.title, field = props.field, className = props.className, rest = __rest(props, ["title", "field", "className"]);
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-anchor-link");
    var CustomTitle = function (props) {
        var list = props.list;
        var hasError = list.some(function (v) { return v === field; });
        return (React.createElement("div", { className: "".concat(globalPrefixCls, "-anchor-custom-link") },
            React.createElement("span", { className: "".concat(globalPrefixCls, "-anchor-custom-link-text") }, title),
            hasError && (React.createElement("div", null,
                React.createElement(IconWarning, { style: { stroke: 'none' } })))));
    };
    return (React.createElement(ErrorLinkListContext.Consumer, null, function (list) {
        if (list === void 0) { list = []; }
        return (React.createElement(ArcoAnchor.Link, __assign({ title: typeof title === 'string' ? React.createElement(CustomTitle, { list: list }) : title }, rest, { "data-tid": "m4b_anchor_link", className: cx(prefixCls, "".concat(globalPrefixCls, "-anchor-child-link"), className) })));
    }));
};
var Link = forwardRef(LinkRender);
Link.displayName = 'AnchorLink';
export default Link;
